// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import InfoCard from "components/InfoCard";

import { useTranslation } from "react-i18next";

function Applist() {
  const { t } = useTranslation();
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <MKTypography variant="h3" fontWeight="bold" mb={1} align="center">
              {t("userInfo.appList.title")}
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              align="center"
              mb={4}
              sx={{ maxWidth: 600, mx: "auto" }}
            >
              {t("userInfo.appList.subtitle")}
            </MKTypography>
            <Grid container justifyContent="flex-start" spacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={5}>
                  <InfoCard
                    icon="phone_iphone"
                    title={t("userInfo.appList.ios.title")}
                    description={t("userInfo.appList.ios.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/ios/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="android"
                    title={t("userInfo.appList.android.title")}
                    description={t("userInfo.appList.android.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/android/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={5}>
                  <InfoCard
                    icon="window"
                    title={t("userInfo.appList.windows.title")}
                    description={t("userInfo.appList.windows.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/windows/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="laptop_mac"
                    title={t("userInfo.appList.macos.title")}
                    description={t("userInfo.appList.macos.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/macos/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={5}>
                  <InfoCard
                    icon="live_tv"
                    title={t("userInfo.appList.smarttv.title")}
                    description={t("userInfo.appList.smarttv.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/android_tv/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="apple"
                    title={t("userInfo.appList.appletv.title")}
                    description={t("userInfo.appList.appletv.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/apple_tv/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.setupLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={5}>
                  <InfoCard
                    icon="router"
                    title={t("userInfo.appList.openwrt.title")}
                    description={t("userInfo.appList.openwrt.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/openwrt/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="router"
                    title={t("userInfo.appList.merlin.title")}
                    description={t("userInfo.appList.merlin.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/merlin/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="terminal"
                    title={t("userInfo.appList.linux.title")}
                    description={t("userInfo.appList.linux.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/linux/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.downloadLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <InfoCard
                    icon="hub"
                    title={t("userInfo.appList.thirdParty.title")}
                    description={t("userInfo.appList.thirdParty.description")}
                  />
                  <MKTypography
                    variant="button"
                    component="a"
                    href="/client/thirdparty/"
                    sx={{
                      mt: 1,
                      display: "inline-block",
                      textDecoration: "underline",
                      color: "#007bff",
                    }}
                  >
                    {t("userInfo.appList.setupLink")}
                  </MKTypography>
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Applist;
